module.exports = __webpack_public_path__ + "assets/img/login_tu2.e6377395.png";